import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import { GlobalConstants } from "../../constants/GlobalConstants";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  return <LmsTable
    actionButtons={[
      { 
        action: GlobalConstants.TableDefaultActions.SUBMIT_SELECTED,
        text: "Submit To Inspection Company",
        submitSuffix: "draws/submit-to-nwcc",
        method: "PUT",
        icon: GlobalConstants.Icons.CARET_UP,
        refreshDataOnSuccess: true,
        isDisabled: (checkedItems) => checkedItems?.length < 1
      },
    ]}
    apiSuffix="draws/submit-to-inspection-companies"
    columnLabelsDictionary={{ 
      je: "JE", 
      borrowerOrganization: "Borrower", 
      submitToNwcc: "Submit to Inspection Company", 
      nwccsubmittedOn: "Inspection Company Submitted On", 
      nwccdateInspected: "Inspection Company Date Inspected", 
      nwccdateReturned: "Inspection Company Date Returned", 
      nwccprojectNo: "Inspection Company Project No", 
      bcportalStatus: "BC Portal Status", 
      ach: "ACH", 
      brms: "BRMs"
    }}
    skipClick
  />;
};

const LmsInspectionsSubmitToInspectionCompany = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }
  return (<MainTable />);
};

export default LmsInspectionsSubmitToInspectionCompany;